import React from 'react';
import Button from '@components/ui/Button';
import { PHONE_NUMBER, PHONE_NUMBER_TEL } from '@utils/constants';

interface HeroSectionProps {
  onBookNowClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onBookNowClick }) => {
  return (
    <section className="bg-gradient-to-r from-sky-500 to-blue-600 text-white py-16 relative overflow-hidden">
      <div className="container mx-auto px-4 relative">
        <div className="flex flex-col items-center">
          <div className="max-w-3xl w-full">
            <h1 className="text-4xl md:text-5xl font-bold mb-2 text-center">
              Golf Cart Rentals
            </h1>
            <p
              className="text-xl mb-6 text-sky-50 text-center"
              style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic' }}
            >
              Clearwater, Florida
            </p>

            {/* Golf Cart Image */}
            <div className="mb-4">
              <img
                src="/Model_cart.jpeg"
                alt="Luxury Golf Cart"
                className="rounded-lg shadow-xl mx-auto"
                style={{ maxWidth: '600px', width: '100%' }}
              />
              <p className="text-center text-sky-50 mt-3 text-lg">
                Explore the town in style. Free Delivery!
              </p>
            </div>

            {/* Book Now and Call Now Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button
                variant="orange"
                size="xl"
                onClick={onBookNowClick}
                className="w-full sm:w-auto"
              >
                Book Now!
              </Button>
              <Button
                variant="primary"
                size="xl"
                href={PHONE_NUMBER_TEL}
                className="w-full sm:w-auto"
              >
                Call Now: {PHONE_NUMBER}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;